import { GetActiveDreamHashTags } from "./GetActiveDreamHashTags";


export function IsDreamHashTagActive(hashTag: string) {
    const activeHashTags = GetActiveDreamHashTags();
    return activeHashTags.includes(hashTag);
}
